var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_vm._v("Confirma eliminación relación Camión/Conductor")])],1),_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('b-button',{attrs:{"size":"sm","variant":"outline-dark"},on:{"click":function($event){return _vm.Eliminar()}}},[_vm._v("Eliminar")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }